// extracted by mini-css-extract-plugin
module.exports = {"paging":"style-module--paging--3RAvh","pagingCarrier":"style-module--pagingCarrier--1eFsZ"};